import { createContext, useState } from "react";

export const ApiTokenContext = createContext();

export const ApiTokenProvider = ({ children }) => {
  const [apiToken, setApiToken] = useState(null);

  return (
    <ApiTokenContext.Provider value={{ apiToken, setApiToken }}>
      {children}
    </ApiTokenContext.Provider>
  );
};